import { isObject } from ".."
import { getTimezoneLessMoment } from "../momentjs"
import { EUROPEAN_DATE } from "../constants"

export const dateGetters = {
  startDate: entity => isObject(entity) ? getTimezoneLessMoment(entity.startDate).format(EUROPEAN_DATE) : null,
  endDate: entity => isObject(entity) ? getTimezoneLessMoment(entity.endDate).format(EUROPEAN_DATE) : null
}